import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './otStyle.css';
import config from '../../config.json';
import OTLabel from './OTLabel';

const apiUrl = config.apiUrl;

const OTDetails = () => {
    const [overtimeDetails, setOvertimeDetails] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        Duration: '',
        Remarks: '',
        Status: '',
        CreatedBy: '',
        CreatedDate: '',
        ApprovedBy: '',
        ApprovedDate: '',
        UpdatedBy: '',
        UpdatedDate: '',
    });

    const { overtimeId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchOvertimeData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Overtime/${overtimeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch overtime data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setOvertimeDetails({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                    CreatedBy: data.Details.CreatedBy,
                    CreatedDate: data.Details.CreatedDate,
                    ApprovedBy: data.Details.ApprovedBy,
                    ApprovedDate: data.Details.ApprovedDate,
                    UpdatedBy: data.Details.UpdatedBy,
                    UpdatedDate: data.Details.UpdatedDate,
                });
            } catch (error) {
                setErrorMessage('Error fetching overtime data');
                setSuccessMessage('');
            }
        };

        fetchOvertimeData();
    }, []);

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        Duration,
        Remarks,
        Status,
        CreatedBy,
        CreatedDate,
        ApprovedBy,
        ApprovedDate,
        UpdatedBy,
        UpdatedDate,
    } = overtimeDetails;

    return (
        <div>
            {userAccess.hasView ? (
                <>
                    <h3>View Overtime</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <div className="row mt-4">
                        <OTLabel label="Transaction ID" value={TransactionID} />
                        <OTLabel label="Transaction Date" value={TransactionDate} />
                        <OTLabel label="Employee" value={Employee.Name} />
                        <OTLabel label="Date Start" value={DateStart} />
                        <OTLabel label="Date End" value={DateEnd} />
                        <OTLabel label="Duration" value={Duration} />
                        <OTLabel label="Remarks" value={Remarks} />
                        <OTLabel label="Status" value={Status} />
                        <OTLabel label="CreatedBy" value={CreatedBy} />
                        <OTLabel label="CreatedDate" value={CreatedDate} />
                        <OTLabel label="UpdatedBy" value={UpdatedBy} />
                        <OTLabel label="UpdatedDate" value={UpdatedDate} />
                        <OTLabel label="ApprovedBy" value={ApprovedBy} />
                        <OTLabel label="ApprovedDate" value={ApprovedDate} />

                        <div className="mb-2">
                            <Link to="/overtime-list" className="btn btn-secondary">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <Link
                                    to={`/overtime-update/${overtimeId}`}
                                    className={`btn btn-primary ms-2 ${Status === 'Approved' || Status === 'Rejected' ? 'disabled' : ''}`}
                                >
                                    Edit
                                </Link>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default OTDetails;